import { Component, ElementRef, HostListener, OnInit, viewChild, input, signal, inject, ChangeDetectionStrategy } from '@angular/core';
import { AnimationService } from 'src/app/services/animation/animation.service';
import { gsap } from 'gsap';
import { CursorService } from 'src/app/services/cursor_animation/cursor.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavComponent implements OnInit {
  private cursorService = inject(CursorService);
  private animation = inject(AnimationService);

  isScrolled = input<boolean>(false);
  offcanvasNavbar = viewChild.required<ElementRef>('offcanvasNavbar');

  logoImage: string = "assets/icons/zumera_icon_white.png";
  logoScrolled = signal(false);

  ngOnInit(): void {
  }

  onMouseEnter(): void {
    this.cursorService.hoverElement();
  }

  onMouseLeave(): void {
    this.cursorService.unhoverElement();
  }
  
  ngAfterViewInit(): void {
    const navbar = this.offcanvasNavbar().nativeElement;
    const observer = new MutationObserver(mutations => {
      mutations.forEach((mutation: any) => {
        if (mutation.attributeName === 'class' && mutation.target.classList.contains('hiding')) {
          gsap.to(".nav-link", {
            opacity: 1,
            x: 300, 
            duration: 0.5,
            ease: "power2.out",
            stagger: {
              amount: 0.5,
              from: "end"
            },
            onComplete: () => {
              gsap.set(".nav-link", { visibility: "hidden" });
            }
          });
        }
      });
    });

    observer.observe(navbar, { attributes: true });
  }

  slideNavlinks(){
    if (this.offcanvasNavbar()) {
      gsap.to(".nav-link", {
        opacity: 1,
        x: 0,
        duration: 0.5,
        stagger: {
          amount: 1,
          from: "start"
        },
        ease: "power2.out",
        visibility: "visible"
      });
    } 
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event): void {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    if (scrollPosition > 200) {
      this.logoScrolled.set(true);
    } else {
      this.logoScrolled.set(false);
    }
  }
}
